var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('DatePicker',{ref:"dateComponentRef",staticClass:"customgrid-date-bar",attrs:{"label":_vm.$t('date'),"clearable":""},on:{"input":_vm.onSearch},model:{value:(_vm.searchText),callback:function ($$v) {_vm.searchText=$$v},expression:"searchText"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }